const envConfig = {
  urlBase: 'https://api.kmrecipes.com',
};

module.exports = { envConfig };
